import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';

const DocumentsDashboard = () => {
  const navigate = useNavigate();
  const { user, isAuthenticated } = useAuth();
  const [vaultDocuments, setVaultDocuments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const API_BASE = '/api/documents';

  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/login');
      return;
    }

    fetchVaultDocuments();
  }, [isAuthenticated]);

  const fetchVaultDocuments = async () => {
    try {
      setLoading(true);

      // CRITICAL FIX: Get token and add Authorization header
      const token = localStorage.getItem('access_token');

      if (!token) {
        console.error('No access token found');
        setVaultDocuments([]);
        setLoading(false);
        return;
      }

      const response = await fetch(`${API_BASE}/vault`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        credentials: 'include'
      });

      if (response.ok) {
        const data = await response.json();
        setVaultDocuments(data.documents || []);
      } else {
        setVaultDocuments([]);
      }
    } catch (err) {
      console.error('Error fetching vault:', err);
      setError(err.message);
      setVaultDocuments([]);
    } finally {
      setLoading(false);
    }
  };

  const handleDownload = async (documentId) => {
    try {
      // CRITICAL FIX: Get token and add Authorization header
      const token = localStorage.getItem('access_token');

      if (!token) {
        console.error('No access token found');
        alert('Authentication required. Please log in again.');
        return;
      }

      const response = await fetch(`${API_BASE}/vault/${documentId}/download`, {
        headers: {
          'Authorization': `Bearer ${token}`
        },
        credentials: 'include'
      });

      if (response.ok) {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `document_${documentId}.docx`;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove();
      }
    } catch (err) {
      console.error('Error downloading:', err);
    }
  };

  if (loading) {
    return (
      <div style={{ padding: '40px', textAlign: 'center' }}>
        <h2>Loading your documents...</h2>
      </div>
    );
  }

  return (
    <div style={{ padding: '40px', maxWidth: '1200px', margin: '0 auto' }}>
      <div style={{ marginBottom: '30px' }}>
        <h1>Document Library</h1>
        <p>Welcome back, {user?.email || user?.name}</p>
      </div>

      <div style={{ 
        display: 'grid', 
        gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', 
        gap: '20px', 
        marginBottom: '40px' 
      }}>
        <div
          onClick={() => navigate('/documents/templates')}
          style={{
            padding: '30px',
            border: '2px solid #4A90E2',
            borderRadius: '8px',
            cursor: 'pointer',
            transition: 'all 0.3s',
            background: 'white'
          }}
        >
          <h3>{'\u{1F4C4}'} Generate Documents</h3>
          <p>Browse templates and create new documents</p>
        </div>

        <div
          onClick={() => navigate('/documents/training')}
          style={{
            padding: '30px',
            border: '2px solid #50C878',
            borderRadius: '8px',
            cursor: 'pointer',
            transition: 'all 0.3s',
            background: 'white'
          }}
        >
          <h3>{'\u{1F393}'} Training Modules</h3>
          <p>Employee training and assessments</p>
        </div>

        <div
          onClick={() => navigate('/documents/settings')}
          style={{
            padding: '30px',
            border: '2px solid #F5A623',
            borderRadius: '8px',
            cursor: 'pointer',
            transition: 'all 0.3s',
            background: 'white'
          }}
        >
          <h3>{'\u{2699}\u{FE0F}'} Document Settings</h3>
          <p>Your salon's details and policies, used to complete every document</p>
        </div>
      </div>

      <div>
        <h2>Your Document Vault ({vaultDocuments.length})</h2>
        {error && <p style={{ color: 'red' }}>{error}</p>}

        {vaultDocuments.length === 0 ? (
          <p>No documents yet. Generate your first document!</p>
        ) : (
          <div style={{ display: 'grid', gap: '15px' }}>
            {vaultDocuments.map(doc => (
              <div
                key={doc.id}
                style={{
                  padding: '20px',
                  border: '1px solid #e0e0e0',
                  borderRadius: '8px',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center'
                }}
              >
                <div>
                  <h4 style={{ margin: '0 0 5px 0' }}>{doc.document_name || doc.file_name}</h4>
                  <p style={{ margin: 0, fontSize: '0.9rem', color: '#666' }}>
                    Generated: {new Date(doc.generated_at).toLocaleDateString()}
                  </p>
                </div>
                <button
                  onClick={() => handleDownload(doc.id)}
                  style={{
                    padding: '10px 20px',
                    background: '#4A90E2',
                    color: 'white',
                    border: 'none',
                    borderRadius: '6px',
                    cursor: 'pointer'
                  }}
                >
                  Download
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default DocumentsDashboard;